import React, { useState } from "react";
//import { PropTypes } from "prop-types";

import { LinkSimple } from "../../_atoms/_link-simple/LinkSimple";
import { Alert } from "../../_molecules/_alert/Alert";

import "./_list-selector.scss";
export const ListSelectorMultiple = ({
  name,
  desc,
  id,
  address,
  onClick,
  onChange,
  price,
  special,
  button,
  value,
  icon,
  alert,
  active,
  css,
  disabled,
}) => {
  const [state, setState] = useState({ open: false, checked: false });
  const { open } = state;
  const handleClick = (e) => {
    e.stopPropagation();
    const { open } = state;

    open
      ? setState({ ...state, open: false })
      : setState({ ...state, open: true });
  };

  const status = open ? "is-active" : "";

  return (
    <div className="list-selector">
      <div className="form__group">
        <div className="checkbox-simple">
          <input
            id={id}
            name={id}
            type="checkbox"
            value={value}
            onChange={onChange}
            checked={active}
            disabled={disabled}
          />
          <label htmlFor={id}>
            <span className="list-selector__contents">
              <span className="list-selector__name">{name}</span>
              <span className="list-selector__price">
                {special && (
                  <span className="list-selector__special">{special} €</span>
                )}
                {price} €
                {icon && (
                  <svg className="icon" role="presentation">
                    <use xlinkHref={`./svg/sprite.svg#${icon}`}></use>
                  </svg>
                )}
                {disabled && (
                  <svg className="icon icon--success" role="presentation">
                    <use xlinkHref={`./svg/sprite.svg#form-success`}></use>
                  </svg>
                )}
              </span>
              <LinkSimple
                onClick={handleClick}
                aria=""
                type=""
                css={status}
                children=""
                href=""
                disabled=""
              >
                {button}{" "}
                <svg className="icon" role="presentation">
                  <use xlinkHref="./svg/sprite.svg#close"></use>
                </svg>
              </LinkSimple>
            </span>
            <span className={`list-selector__detail ${status}`}>
              <hr />
              {desc}

              {alert && (
                <>
                  <br />
                  <Alert css="alert--info">
                    <ul className="list list--icons list--icons--md">
                      <li>
                        <div className="text">
                          <svg className="icon">
                            <use xlinkHref="./svg/sprite.svg#form-info"></use>
                          </svg>
                          {alert}
                        </div>
                      </li>
                    </ul>
                  </Alert>
                </>
              )}
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

// ListSelector.propTypes = {
//   name: PropTypes.string.isRequired,
// };
